import Component from ".";
import authRoles from "../../utils/auth.roles";
const VerificationRoutes = {
  auth: authRoles.user,
  kyc: true,
  routes: [
    {
      path: "/verification",
      component: Component,
      exact: true,
    },
  ],
};
export default VerificationRoutes;
